import React, { useState, useEffect } from 'react';
import CookieBanner from './CookieBanner';
import CookiePreferences from './CookiePreferences';
import { 
  shouldShowBanner, 
  acceptAll, 
  rejectAll, 
  saveConsent 
} from '../../utils/cookieConsent';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);

  useEffect(() => {
    // Check if we should show banner
    setShowBanner(shouldShowBanner());

    // Listen for custom event to reopen preferences
    const handleReopenPreferences = () => {
      setShowPreferences(true);
    };

    window.addEventListener('openCookiePreferences', handleReopenPreferences);

    return () => {
      window.removeEventListener('openCookiePreferences', handleReopenPreferences);
    };
  }, []);

  const handleAcceptAll = () => {
    acceptAll();
    setShowBanner(false);
    setShowPreferences(false);
  };

  const handleRejectAll = () => {
    rejectAll();
    setShowBanner(false);
    setShowPreferences(false);
  };

  const handleCustomize = () => {
    setShowPreferences(true);
  };

  const handleSavePreferences = (preferences) => {
    saveConsent(preferences);
    setShowBanner(false);
    setShowPreferences(false);
  };

  const handleClosePreferences = () => {
    setShowPreferences(false);
    // If banner was showing, keep it showing
    if (shouldShowBanner()) {
      setShowBanner(true);
    }
  };

  return (
    <>
      {showBanner && (
        <CookieBanner
          onAcceptAll={handleAcceptAll}
          onRejectAll={handleRejectAll}
          onCustomize={handleCustomize}
        />
      )}
      
      <CookiePreferences
        isOpen={showPreferences}
        onClose={handleClosePreferences}
        onSave={handleSavePreferences}
      />
    </>
  );
};

export default CookieConsent;

// Helper function to open preferences from anywhere in the app
export const openCookiePreferences = () => {
  window.dispatchEvent(new Event('openCookiePreferences'));
};
